import { PointOfInterest } from '../components/SectionBlocks/blocks/Charts/RouteCharts';
import { RichGeopoint } from '../../../types/routeBlockType';
import { RouteData } from '../../../types/mapsApiTypes';
import { TravelMode } from '../../../types/TravelSuggestionType';
import { useMapsApiRouteData } from './useMapsApiRouteData';

type Input = {
  routepoints?: RichGeopoint[];
  elevation?: number[];
  travelMode?: TravelMode;
};

type Output = {
  directions?: google.maps.DirectionsResult;
  routeData?: RouteData;
  pointsOfInterest: PointOfInterest[];
  isLoading: boolean;
  error?: Error;
};

/**
 * Unified hook for fetching route data
 *
 * This hook provides a single interface for all components that need route and POI data,
 * ensuring consistent data flow regardless of which implementation is active.
 * @param routepoints Array of waypoints for the route
 * @param elevation Optional elevation profile
 * @param travelMode Travel mode (only used when backend implementation is active)
 * @returns Unified data structure with routeData, POI, loading, error
 */
export const useElPrixRouteData = ({ routepoints, elevation, travelMode = TravelMode.CAR }: Input): Output => {
  const backendData = useMapsApiRouteData({
    routepoints,
    elevation,
    travelMode,
  });

  return {
    routeData: backendData.routeData,
    pointsOfInterest: backendData.pointsOfInterest,
    isLoading: backendData.isLoading,
    error: backendData.error,
  };
};
